function GemIcon({ white = false }: { white?: boolean }) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_2200_12918)">
				<mask
					id="mask0_2200_12918"
					style={{ maskType: "luminance" }}
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="25"
					height="24"
				>
					<path
						d="M0.00390625 1.90735e-06H24.0039V24H0.00390625V1.90735e-06Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask0_2200_12918)">
					<path
						d="M23.2984 9.63538C23.2792 9.83924 23.1953 10.0373 23.0485 10.1961L12.7105 21.3932C12.5676 21.5486 12.3857 21.6451 12.1949 21.6834C12.0701 21.7079 11.9416 21.7079 11.8169 21.6834C11.6259 21.6451 11.4442 21.5486 11.3012 21.3932L0.963188 10.1961C0.816423 10.0373 0.732468 9.83924 0.713297 9.63538C0.692672 9.41859 0.745922 9.19551 0.875438 9.0051L5.16183 2.71701C5.34028 2.45507 5.63719 2.29823 5.95425 2.29823H18.0575C18.3745 2.29823 18.6714 2.45507 18.8499 2.71701L23.1363 9.0051C23.2658 9.19551 23.319 9.41859 23.2984 9.63538Z"
						stroke={white ? "white" : "#4D5561"}
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M12.006 21.6835L7.00391 9.63543L10.5511 2.29827"
						stroke={white ? "white" : "#4D5561"}
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M12.0059 21.6835L17.0079 9.63543L13.4607 2.29827"
						stroke={white ? "white" : "#4D5561"}
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M0.710938 9.63525H7.00142H17.0056H23.2961"
						stroke={white ? "white" : "#4D5561"}
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_2200_12918">
					<rect width="24" height="24" fill={white ? "white" : "#4D5561"} />
				</clipPath>
			</defs>
		</svg>
	);
}

export default GemIcon;
